import styles from "./styles.module.css";

interface LoadingProps {
  message?: string;
  subtitle?: string;
}

export const Loading = ({
  message = "Carregando",
  subtitle,
}: LoadingProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.spinner}>
        <div className={styles.spinnerRing} />
      </div>

      <div className={styles.textWrapper}>
        <p className={styles.loadingMessage}>
          {message}
          <span className={styles.dots}>
            <span className={styles.dot}>.</span>
            <span className={styles.dot}>.</span>
            <span className={styles.dot}>.</span>
          </span>
        </p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
};
